const URL = {
  GET_PRIMARY_INTERESTS: 'marketing/primary-interests',
}

export default URL
